import React from 'react';
import { Step, StepLabel } from '@mui/material';
import { CustomStepper } from '../styles/StyledComponents';

const StepperWrapper = ({ steps, activeStep }) => {
  return (
    <CustomStepper activeStep={activeStep} alternativeLabel>
      {steps.map((label) => (
        <Step key={label}>
          <StepLabel>{label}</StepLabel>
        </Step>
      ))}
    </CustomStepper>
  );
};

export default StepperWrapper;